import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { createSelectors } from '../utils/createSelector'
import { isValidEmail } from '../../Utils/email'

type NotificationSubscriptionState = {
  isNewClientNotificationSubscriptionModalOpen: boolean
  email: string
  firmUuid: string
  errors: Record<string, string>
  isDirty: boolean
}

type NotificationSubscriptionActions = {
  resetState: () => void
  toggleNewClientNotificationSubscriptionModal: () => void
  validateForm: () => void
  setEmail: (email: string) => void
  setFirmUuid: (firmUuid: string) => void
  openNewClientNotificationSubscriptionModal: (firmUuid: string) => void
}

const defaultState: NotificationSubscriptionState = {
  isNewClientNotificationSubscriptionModalOpen: false,
  email: '',
  firmUuid: '',
  errors: {},
  isDirty: false,
}

export const useNotificationSubscriptionStore = createSelectors(
  create<NotificationSubscriptionState & NotificationSubscriptionActions>()(
    immer((set) => ({
      ...defaultState,

      toggleNewClientNotificationSubscriptionModal: () =>
        set((state) => {
          state.isNewClientNotificationSubscriptionModalOpen =
            !state.isNewClientNotificationSubscriptionModalOpen
        }),

      setEmail: (email: string) => set({ email, isDirty: true }),
      setFirmUuid: (firmUuid: string) => set({ firmUuid }),

      validateForm: () =>
        set((state) => {
          state.errors = {}
          if (!isValidEmail(state.email)) {
            state.errors.email = 'Veuillez entrer une adresse email valide'
          }

          if (!state.firmUuid) {
            state.errors.firmUuid = 'Veuillez sélectionner une entreprise'
          }
        }),

      openNewClientNotificationSubscriptionModal: (firmUuid: string) =>
        set({
          firmUuid,
          isNewClientNotificationSubscriptionModalOpen: true,
        }),

      resetState: () => set(defaultState),
    })),
  ),
)
